
import React from 'react';
import { Utensils, MapPin, Film } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface TabNavigationProps {
  activeTab: 'food' | 'hospitals' | 'reels';
  setActiveTab: (tab: 'food' | 'hospitals' | 'reels') => void;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ activeTab, setActiveTab }) => {
  const { t } = useTranslation();
  
  return (
    <div className="flex rounded-xl overflow-hidden border border-gray-200 mb-4">
      <button 
        className={`flex-1 py-3 flex justify-center items-center space-x-2 ${activeTab === 'food' ? 'bg-sangre-500 text-white' : 'bg-white text-gray-700'}`}
        onClick={() => setActiveTab('food')}
      >
        <Utensils className="w-4 h-4" />
        <span>{t('food')}</span>
      </button>
      <button 
        className={`flex-1 py-3 flex justify-center items-center space-x-2 ${activeTab === 'hospitals' ? 'bg-sangre-500 text-white' : 'bg-white text-gray-700'}`}
        onClick={() => setActiveTab('hospitals')}
      >
        <MapPin className="w-4 h-4" />
        <span>{t('hospitals')}</span>
      </button>
      <button 
        className={`flex-1 py-3 flex justify-center items-center space-x-2 ${activeTab === 'reels' ? 'bg-sangre-500 text-white' : 'bg-white text-gray-700'}`}
        onClick={() => setActiveTab('reels')}
      >
        <Film className="w-4 h-4" />
        <span>{t('reels')}</span>
      </button>
    </div>
  );
};

export default TabNavigation;
